export default "__VITE_ASSET__Cs4dcN$u__"